import React from "react";
import { ChefHat, Coins, Plus } from "lucide-react";

import CartItemCard from "../../components/cart/CartItemCard";

const dinheiro = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

// Última tela antes da cozinha. Repete a mesa em destaque (é a hora em que o
// erro de mesa errada ainda custa barato) e não pede forma de pagamento: na
// mesa se paga no fim.
//
// Cada produto aparece no cartão de item padrão do sistema (o mesmo das
// Mesas no painel), só leitura: foto, a observação que o cliente escreveu no
// produto e as escolhas de cada etapa. Não há mais campo de observação da
// rodada — a observação é do produto (pedido do dono, 23/09).
export default function ConferenciaMesa({
  mesa, itens, produtos, onVoltar, onEnviar, enviando, darkMode, cashbackGanho,
}) {
  const total = itens.reduce(
    (soma, i) => soma + Number(i.final_price ?? i.sale_price ?? 0) * Number(i.quantity || 1), 0);
  const fundo = darkMode ? "bg-zinc-950 text-zinc-100" : "bg-white text-zinc-900";

  return (
    <div className={`fixed inset-0 z-[60] flex flex-col ${fundo}`} data-e2e="mesa-conferencia">
      <div className="px-4 pt-6">
        <div className="rounded-2xl bg-primary/10 border-2 border-primary/30 px-4 py-3 text-center">
          <p className="text-[11px] uppercase tracking-widest opacity-70">Este pedido vai para a</p>
          <p className="text-2xl font-black text-primary" data-e2e="mesa-confirmacao">
            {(mesa?.nome || `Mesa ${mesa?.numero ?? ""}`).toUpperCase()}
          </p>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-2">
        {itens.map((item, idx) => (
          <CartItemCard key={item.cartItemId || idx} item={item} allProducts={produtos} readonly />
        ))}
      </div>
      <div className={`px-4 pt-3 pb-6 border-t ${darkMode ? "border-zinc-800" : "border-zinc-200"}`}>
        {cashbackGanho > 0 ? (
          <p className="flex items-center justify-center gap-1.5 text-xs font-bold text-emerald-500 mb-2">
            <Coins className="w-3.5 h-3.5" /> Você ganha {dinheiro(cashbackGanho)} de cashback
          </p>
        ) : null}
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm opacity-70">Total desta rodada</span>
          <span className="text-2xl font-black">{dinheiro(total)}</span>
        </div>
        <button
          type="button"
          onClick={() => onEnviar()}
          disabled={enviando || itens.length === 0}
          data-e2e="mesa-enviar"
          className="w-full h-16 rounded-full bg-primary text-primary-foreground text-lg font-black flex items-center justify-center gap-2 active:scale-[0.98] transition disabled:opacity-60"
        >
          <ChefHat className="w-5 h-5" />
          {enviando ? "ENVIANDO..." : "ENVIAR PARA A COZINHA"}
        </button>
        <button
          type="button"
          onClick={onVoltar}
          disabled={enviando}
          data-e2e="mesa-escolher-mais"
          className="mt-2 w-full h-12 rounded-full border-2 border-primary/40 text-primary text-sm font-black flex items-center justify-center gap-1.5 active:scale-[0.98] transition disabled:opacity-60"
        >
          <Plus className="w-4 h-4" /> ESCOLHER MAIS PRODUTOS
        </button>
      </div>
    </div>
  );
}
